import React from "react";
import { Box } from "@mui/material";
import { CustomTab, CustomTabs } from "../tabs/Tabs";

export const consultationCustomerTypes = ["normal", "potential", "power"];

const ConsultationCustomerTabs = ({ value, onChange, includeAll = false, allLabel = "All Users" }) => {
  const customerTypes = includeAll ? ["all", ...consultationCustomerTypes] : consultationCustomerTypes;
  const activeIndex = Math.max(0, customerTypes.indexOf(value));
  return (
    <Box sx={{ width: "100%", mb: 2 }}>
      <CustomTabs value={activeIndex} onChange={(_event, index) => onChange(customerTypes[index])}>
        {includeAll && <CustomTab label={allLabel} />}
        <CustomTab label="Normal Customers" />
        <CustomTab label="Potential Power Customers" />
        <CustomTab label="Power Customers" />
      </CustomTabs>
    </Box>
  );
};

export default ConsultationCustomerTabs;
